module.exports = __webpack_public_path__ + "img/view-project-docs.ee2b0052.png";